import { Component } from "react";
import { RefreshCw, TriangleAlert } from "lucide-react";
import { Button, EmptyState } from "./ui";

/** Isola falhas de uma tela para o resto do painel continuar funcionando. */
export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Erro na tela:", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="card">
        <EmptyState
          icon={TriangleAlert}
          title="Esta tela encontrou um erro"
          action={
            <Button icon={RefreshCw} onClick={() => window.location.reload()}>
              Recarregar
            </Button>
          }
        >
          {String(this.state.error.message || this.state.error)}
        </EmptyState>
      </div>
    );
  }
}
